import { withClassName } from 'lp-hoc'

const ContentBlock = withClassName('content-block')('div')

export default ContentBlock
